import { Skeleton } from "antd";
import type { IEmployee } from "../../../../app/features/employee/employee.types";
import Section from "../_icons/Section";
import Info from "./Info";

type Props = {
  data?: IEmployee;
  loading?: boolean;
};

export default function TechnicalInfo({ data, loading }: Props) {
  if (loading) {
    return (
      <Section
        title="অন্যান্য টেকনিক্যাল সার্টিফিকেট/লাইসেন্স"
        type="technical"
      >
        <Skeleton active paragraph={{ rows: 2 }} />
      </Section>
    );
  }

  const technicalDocs =
    data?.otherDocs?.filter((doc) => doc.type === "TECHNICAL") || [];

  return (
    <Section title="অন্যান্য টেকনিক্যাল সার্টিফিকেট/লাইসেন্স" type="technical">
      {technicalDocs.length ? (
        technicalDocs.map((doc, index) => (
          <Info
            key={index}
            label="সার্টিফিকেট/লাইসেন্স"
            value={doc.name}
            img={doc.url}
          />
        ))
      ) : (
        <div className="text-sm text-gray-500">কোন তথ্য নেই</div>
      )}
    </Section>
  );
}
